import storageClientTarget from '@utils/storageClientTarget';
import constants from './constants';

function userUpdate(user, isFirstTime = false) {

  const clientTargetStorage = storageClientTarget.get();
  // eslint-disable-next-line no-param-reassign
  user.clients = [{
    id: 'CL', name: 'Celsia', domain: 'celsia', properties: null,
  }];
  const { clients } = user;
  let clientTarget = clientTargetStorage || (clients.length > 0 ? clients[0] : null);
  if (clientTarget) {

    // update client target
    const { id } = clientTarget;
    const clientData = clients.find(({ id: dataId }) => dataId === id);
    if (clientData) clientTarget = clientData;
    storageClientTarget.save(clientTarget);

  } else {

    storageClientTarget.remove();

  }

  return {
    type: constants.USER_UPDATE,
    payload: { ...user, clientTarget, isFirstTime },
  };

}

function userLogout() {

  storageClientTarget.remove();
  return {
    type: constants.USER_LOGOUT,
  };

}

function setClientTarget(clientTarget) {

  // eslint-disable-next-line
  return (dispatch, getState) => {

    const { user } = getState();

    dispatch({
      type: constants.USER_LOGOUT,
    });

    storageClientTarget.save(clientTarget);

    dispatch({
      type: constants.USER_UPDATE,
      payload: { ...user, clientTarget },
    });

  };

}

function setFirstTime(newBool) {

  return {
    type: constants.SET_FIRST_TIME,
    payload: newBool,
  };

}

function updateClientTarget(newClienTarget) {

  // eslint-disable-next-line
  return (dispatch, getState) => {

    const { user } = getState();
    const { clients } = user;
    const { id: idTarget } = newClienTarget;
    const indexTarget = clients.findIndex(({ id }) => id === idTarget);
    if (indexTarget !== -1) {

      const newClients = [...clients];
      newClients[indexTarget] = newClienTarget;
      storageClientTarget.save(newClienTarget);

      const newUser = { ...user, clients: newClients };
      dispatch({
        type: constants.USER_UPDATE,
        payload: { ...newUser, clientTarget: newClienTarget, isFirstTime: false },
      });

    }

  };

}

const setCreateEditUser = (values) => (dispatch) => {

  dispatch({
    type: constants.USER_CREATE_EDIT_USER,
    payload: values,
  });

};

const setIdUserEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.USER_EDIT_ID,
    payload: values,
  });

};

export default {
  userUpdate,
  userLogout,
  setClientTarget,
  setFirstTime,
  updateClientTarget,
  setCreateEditUser,
  setIdUserEdit,
};
